package com.essntl.uikit.components.utils

import androidx.compose.runtime.Stable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object EsConstants {
    val SpacingUnit = 8.dp

    val LargeButtonHeight = 42.dp
    val MediumButtonHeight = 38.dp
    val SmallButtonHeight = 30.dp

    val LargeIconSize = 22.dp
    val MediumIconSize = 20.dp
    val SmallIconSize = 16.dp

    val ButtonBorderRadius = 80.dp
    val SectionBorderRadius = 18.dp

    val SectionVerticalPadding = 1.spacing
    val SectionHorizontalPadding = 1.spacing

    val LargeSectionVerticalPadding = 2.spacing
    val LargeSectionHorizontalPadding = 3.spacing

    val ButtonBorderWidth = 4.dp

    val ListRowItemHeight = 50.dp
    val RoundedCornerSize = 18.dp
    val ListRowVerticalPadding = 8.dp
    val ListRowHorizontalPadding = 8.dp
    val ListRowVerticalSpacing = 0.dp
    val ListColumnHeaderHeight = 40.dp

    val StatusDropdownVerticalPadding = 0.8.spacing
    val StatusDropdownVerticalPaddingLarge = 1.2.spacing
    val StatusDropdownHorizontalPadding = 1.5.spacing

    object JourneyDayRow {
        val CardPadding = 1.spacing
        val CardHorizontalSpacing = 1.spacing
    }

    val MobileRoundedCornerSize = 24.dp

}

@Stable
inline val Int.spacing: Dp get() = Dp(value = this.toFloat() * EsConstants.SpacingUnit.value)

/**
 * Create a [Dp] using a [Double]:
 *     val left = 10.0
 *     val x = left.dp
 *     // -- or --
 *     val y = 10.0.dp
 */
@Stable
inline val Double.spacing: Dp get() = Dp(value = this.toFloat() * EsConstants.SpacingUnit.value)

/**
 * Create a [Dp] using a [Float]:
 *     val left = 10f
 *     val x = left.dp
 *     // -- or --
 *     val y = 10f.dp
 */
@Stable
inline val Float.spacing: Dp get() = Dp(value = this * EsConstants.SpacingUnit.value)
